import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import ExcelExport from 'export-xlsx';
import { SETTINGS_FOR_EXPORT } from '../../xlsxSettings';

@Component({
  selector: 'app-registrosaccesos',
  templateUrl: './registrosaccesos.component.html',
  styleUrls: ['./registrosaccesos.component.scss']
})
export class RegistrosaccesosComponent implements OnInit {

  clientes: any[] = []
  instalaciones: any[] = []
  instalacionesFiltradas: any[] = []
  accesos: any[] = []
  usuario: any;
  rango: any = [];

  desde: Date;
  hasta: Date;
  loading: boolean = false

  idClienteSeleccionado: string
  idInstalacionSeleccionada: string
  busqueda: string

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
  ) {
    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    let today = new Date()
    today.setHours(0, 0, 0)
    console.log('today', today);

    let tonigth = new Date()
    // tonigth.setDate(tonigth.getDate()-1)
    tonigth.setHours(23, 59, 59)
    console.log('tonigth', tonigth);

    this.rango.push(today)
    this.rango.push(tonigth)

    this.getClientes()
    this.getInstalaciones()
  }

  async ngOnInit(): Promise<void> {
    this.idClienteSeleccionado = await this.http.getLocalstorage('idClienteSeleccionado')
  }

  resetSearch() {
    this.busqueda = null
  }

  async getAccesos(): Promise<void> {
    this.loading = true
    const desde = new Date(this.rango[0]).getTime()
    const _hasta = new Date(this.rango[1])
    const hasta = new Date(_hasta.setHours(23, 59, 59)).getTime()

    console.log('desde', desde);
    console.log('hasta', hasta);

    this.accesos = await this.http.getAccesosMezcladosByClienteService(this.idClienteSeleccionado, desde, hasta);
    console.log('accesos', this.accesos);
    this.loading = false

    this.ngZone.run(() => {
      console.log('ngZone');
    })
  }

  async getClientes(): Promise<void> {
    this.clientes = await this.http.getclientesbyEmpresaService(this.usuario.Empresa._id);
    console.log('clientes', this.clientes);

    this.ngZone.run(() => {
      console.log('ngZone');
    })
  }

  async getInstalaciones(): Promise<void> {
    this.instalaciones = await this.http.getinstalacionesByEmpresaService(this.usuario.Empresa._id);
    console.log('instalaciones', this.instalaciones);

    this.ngZone.run(() => { })

  }

  filtraInstalaciones(event) {
    console.log('filtraInstalaciones');
    this.idClienteSeleccionado = event.value
    console.log('idClienteSeleccionado', this.idClienteSeleccionado);
    this.instalacionesFiltradas = this.instalaciones.filter(e => e.Cliente._id == event.value)
  }

  descargar() {
    console.log('descargar');
    const excelExport = new ExcelExport();

    let _accesos = []
    this.accesos.forEach(e => {

      let bloqueado = 'BLOQUEADO'
      if (!e.Bloqueado)
        bloqueado = 'HABILITADO'

      let fechaSalida = null
      if (e.FechaSalida)
        fechaSalida = new Date(e.FechaSalida).toLocaleString()

      _accesos.push({
        FechaIngreso: new Date(e.FechaIngreso).toLocaleString(),
        FechaSalida: fechaSalida,
        Cliente: e.Cliente.Nombre,
        Instalacion: e.Instalacion.Nombre,
        Usuario: e.UsuarioCedula.NombreCompleto,
        Rut: e.UsuarioCedula._id,
        AutorizadoPor: e.AutorizadoPor,
        Bloqueado: bloqueado,
        SeDirigeA: e.SeDirigeA,
      })
    });



    let data = [{ data: _accesos }]
    console.log('SETTINGS_FOR_EXPORT', SETTINGS_FOR_EXPORT);
    // let now = new Date()
    // let d = now.getDate()
    // let M = now.getMonth() + 1
    // let y = now.getFullYear()
    // let h = now.getHours()
    // let m = now.getMinutes()
    let filename = 'Accesos_' + _accesos[0].Cliente
    SETTINGS_FOR_EXPORT.fileName = filename

    SETTINGS_FOR_EXPORT.workSheets[0].sheetName = 'Accesos'

    let def = [
      {
        name: 'FechaIngreso',
        key: 'FechaIngreso',
        width: 20,
      },
      {
        name: 'FechaSalida',
        key: 'FechaSalida',
        width: 20,
      },
      {
        name: 'Usuario',
        key: 'Usuario',
        width: 30,
      },
      // {
      //   name: 'Cliente',
      //   key: 'Cliente',
      //   width: 25,
      // },
      {
        name: 'Instalación',
        key: 'Instalacion',
        width: 25,
      },
      {
        name: 'RUT',
        key: 'Rut',
        width: 15,
      },
      {
        name: 'SeDirigeA',
        key: 'SeDirigeA',
        width: 20,
      },
      {
        name: 'AutorizadoPor',
        key: 'AutorizadoPor',
        width: 20,
      },
      {
        name: 'Bloqueado',
        key: 'Bloqueado',
        width: 15,
      }
    ]

    SETTINGS_FOR_EXPORT.workSheets[0].tableSettings.data.headerDefinition = def
    excelExport.downloadExcel(SETTINGS_FOR_EXPORT, data);

  }
}
